// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const cancelInReasonOneMax = 4000;

export const CancelIn = zod.object({
  "reason": zod.union([zod.string().max(cancelInReasonOneMax),zod.null()]).optional()
});

export type CancelIn = zod.input<typeof CancelIn>;
export type CancelInOutput = zod.output<typeof CancelIn>;
